export default __webpack_public_path__ + "static/media/cwa-vector-orange.bd434447.webp";